module.exports = __webpack_public_path__ + "assets/img/fcmy-a.712fad5b.png";